/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Changes_DiscardedInputs */

const en_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes discarded`)
};

const fr_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications annulées`)
};

const de_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen verworfen`)
};

const it_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche scartate`)
};

const ru_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения отменены`)
};

const es_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios descartados`)
};

const zh_cn2_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已放弃的更改`)
};

const ja_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更は破棄されました`)
};

const hi_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन खारिज कर दिए गए`)
};

const pt_pt2_knp_terms_changes_discarded = /** @type {(inputs: Knp_Terms_Changes_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações descartadas`)
};

/**
* | output |
* | --- |
* | "Changes discarded" |
*
* @param {Knp_Terms_Changes_DiscardedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_changes_discarded = /** @type {((inputs?: Knp_Terms_Changes_DiscardedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Changes_DiscardedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_changes_discarded(inputs)
	if (locale === "de") return de_knp_terms_changes_discarded(inputs)
	if (locale === "it") return it_knp_terms_changes_discarded(inputs)
	if (locale === "ru") return ru_knp_terms_changes_discarded(inputs)
	if (locale === "es") return es_knp_terms_changes_discarded(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_changes_discarded(inputs)
	if (locale === "ja") return ja_knp_terms_changes_discarded(inputs)
	if (locale === "hi") return hi_knp_terms_changes_discarded(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_changes_discarded(inputs)
	return en_knp_terms_changes_discarded(inputs)
});